export enum ErrorMessage {
  UNKNOWN = "An error occured",
  LICENSE_NOT_FOUND = "LICENSE_NOT_FOUND",
}
